/**
 * Sidebar Element Visibility Rules
 *
 * Controls visibility of desktop sidebar CTA elements.
 */

import { AllowedExperimentKey } from '@tenants/types';
import { ExperimentElement, type VisibilityRule } from '../../types';

/**
 * Sidebar visibility rules
 *
 * Logic:
 * - Connection request sidebar card:
 *   - Show only on desktop when CONNECTION_REQUEST_FORM experiment is active
 */
export const sidebarRules: Partial<Record<ExperimentElement, VisibilityRule>> = {
  [ExperimentElement.SIDEBAR_CONNECTION_REQUEST]: {
    showWhen: {
      experiments: [AllowedExperimentKey.CONNECTION_REQUEST_FORM],
      viewports: ['desktop'],
    },
  },
};
